import gql from 'graphql-tag';
import placeFragment from './place';

const FRAGMENT_DEVICE_POSITION = gql`
  fragment devicePositionDetails on DevicePosition {
    id
    deviceId
    latitude
    longitude
    speed
    rawData
    receivedAt
    generatedAt
    createdAt
  }
`;

const FRAGMENT_DEVICE_SUMMARY = gql`
  fragment deviceSummary on Device {
    id
    workspacePrefixId
    workspacePrefix {
      id
      prefix
      workspaceId
    }
    uniqueId
    customerId
    customer {
      identifier
      name
    }
    workspaceId
    name
    type
    image
    createdAt
    connectionStatus
    lastDeviceEvent
    lastDevicePosition
    isMonitorable
    isActive
    isPushNotificationsEnabled
    modelId
    devicePlaces {
      placeId
      place {
        ...placeDetails
      }
    }
  }
  ${placeFragment.FRAGMENT_PLACE}
`;

const FRAGMENT_DEVICE = gql`
  fragment deviceDetails on Device {
    ...deviceSummary
    speedLimit
    lastPositionId
    currentStatus
    batteryLevel
    networkPowerStatus
    isPowered
    timezone
    config
    deviceCategory {
      id
      description
    }
    labels {
      id
      name
      type
      color
    }
    installer
    asset {
      brand {
        id
        title
      }
      model {
        id
        title
      }
    }
    deviceCustomKeyValues {
      id
      customKeyId
      value
    }
    mirroredDevices {
      id
      name
      image
    }
    placeOpened
  }
  ${FRAGMENT_DEVICE_SUMMARY}
  ${placeFragment.FRAGMENT_PLACE}
`;

const FRAGMENT_DEVICE_REPORTS = gql`
  fragment deviceReports on Device {
    id
    workspacePrefixId
    workspacePrefix {
      id
      prefix
      workspaceId
    }
    uniqueId
    customerId
    workspaceId
    name
    type
    image
    createdAt
    connectionStatus
    lastDeviceEvent
    lastDevicePosition
    isMonitorable
    isActive
    isPushNotificationsEnabled
    modelId
    devicePlaces {
      placeId
      place {
        ...placeDetails
      }
    }
    deviceHistoriesCount(filter: $deviceHistoriesCountFilter)
  }
  ${placeFragment.FRAGMENT_PLACE}
`;

export default {
  FRAGMENT_DEVICE,
  FRAGMENT_DEVICE_SUMMARY,
  FRAGMENT_DEVICE_POSITION,
  FRAGMENT_DEVICE_REPORTS,
};
